import React from 'react';

export type LogoProps = {}

export const Logo: React.FC<LogoProps> = (props) => {
  return (
    <img src={`${process.env.REACT_APP_API_URL}logo`} alt="Logo" width="300" />
  );
};
